import Box from '@/common/components/Box'
import ResumeItem from '@/common/components/ResumeItem'
import { formatCurrency, formatDecimalUnit, formatDecimalWithGroupedUnit } from '@/common/utils/formatters'
import { CompanyContractConsumptionControlledBy } from '@/features/company/types/contract.type'
import { DeleteEntryProductCategoryModal } from '@/features/governmentAllocations/pages/Update/components/DeleteEntryProductCategoryModal'
import { UpdateEntryProductCategoryModal } from '@/features/governmentAllocations/pages/Update/components/UpdateEntryProductCategoryModal'
import { GovernmentAllocationEntryProductCategory } from '@/features/governmentAllocations/types/governmentAllocationEntry.type'
import { BoxesIcon, FileBoxIcon } from 'lucide-react'

interface EntryGovernmentAllocationDetailsQuantityProps {
  companyBranchId?: string
  governmentAllocationId: string
  entryProductCategories: GovernmentAllocationEntryProductCategory[]
  disabled: boolean
  hideButtons?: boolean
  governmentAllocationCurrencyRestricted: boolean | undefined;
}

export const EntryGovernmentAllocationDetailsQuantity = ({
  companyBranchId,
  governmentAllocationId,
  entryProductCategories,
  disabled,
  hideButtons,
  governmentAllocationCurrencyRestricted,
}: EntryGovernmentAllocationDetailsQuantityProps) => {
  return (
    <div className="flex flex-col gap-4">
      {entryProductCategories.map((entryProductCategory) => (
        <Box className="flex flex-col gap-3 p-4" key={entryProductCategory.id}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-x-6">
              <div className="flex items-center gap-x-2 text-white-800">
                <BoxesIcon strokeWidth={1} />

                <p>{entryProductCategory.product_category.display_name}</p>
              </div>

              <div className='flex items-center gap-4'>
                <ResumeItem
                  label="Quantidade limite"
                  value={formatDecimalWithGroupedUnit(
                    Number(entryProductCategory.total_quantity),
                    entryProductCategory.entry_products,
                    (p) => p.product.unit_for_quantity,
                  )}
                  className="text-center"
                />

                {governmentAllocationCurrencyRestricted && (
                  <ResumeItem
                    label="Valor limite"
                    value={formatCurrency(Number(entryProductCategory.total_value))}
                    className="text-center"
                  />
                )}
              </div>
            </div>

            {!hideButtons && (
              <div className="flex gap-x-8">
                <DeleteEntryProductCategoryModal
                  governmentAllocationId={governmentAllocationId}
                  entryProductCategoryId={entryProductCategory.id}
                  disabled={disabled}
                />

                <UpdateEntryProductCategoryModal
                  companyBranchId={companyBranchId}
                  governmentAllocationId={governmentAllocationId}
                  entryProductCategory={entryProductCategory}
                  controlledBy={CompanyContractConsumptionControlledBy.Quantity}
                  governmentAllocationCurrencyRestricted={governmentAllocationCurrencyRestricted}
                />
              </div>
            )}
          </div>

          {entryProductCategory.entry_products.map((entryProduct) => (
            <Box className="py-3 px-3" key={entryProduct.id}>
              <div className="flex items-center justify-between border-s border-blue-800 px-3">
                <div className="flex items-center gap-x-2">
                  <FileBoxIcon strokeWidth={1.5} />

                  <p>{entryProduct.product.display_name}</p>
                </div>

                <div className='flex items-center gap-4'>
                  <ResumeItem
                    label="Quantidade limite"
                    value={formatDecimalUnit(Number(entryProduct.total_quantity), entryProduct.product.unit_for_quantity)}
                    className="text-center"
                  />

                  {governmentAllocationCurrencyRestricted && (
                    <ResumeItem
                      label="Valor limite"
                      value={formatCurrency(Number(entryProduct.total_value))}
                      className="text-center"
                    />
                  )}
                </div>
              </div>
            </Box>
          ))}
        </Box>
      ))}
    </div>
  )
}
